import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import {Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {XatBotDialogService} from "@features/xatbot/services/xat-bot-dialog.service";

@Component({
    standalone: false,
    selector: 'app-xatbot-article-cell-viewer',
  templateUrl: './xatbot-article-cell-viewer.component.html',
  styleUrls: ['./xatbot-article-cell-viewer.component.scss']
})

export class XatbotArticleCellViewerComponent implements OnInit, CellComponent {
  fieldDefinition: FieldDefinition;
  invalidateSubject: InvalidateSubject;
  item: any;
  roles: any;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  ngUnsubscribe$: Subject<void> = new Subject<void>();
  constructor(private xatBotDialogService: XatBotDialogService) { }

  ngOnInit() {
  }

  viewArticle(articleId: string) {
    this.xatBotDialogService.openArticleDialog(articleId);
    return;
  }
}
